import { UserProfileMenu } from './model/userProfileMenu'

export const defaultUserProfileMenu: UserProfileMenu[] = [
	{
		id: 1,
		isMatIcon: false,
		iconName: 'fa-user',
		description: 'my_profile',
		action: '/profile',
		roles: ['1', '2', '6', '400001', '400028', '400035', '400036', '400037', '400038', '7', '5', '8', '9', '3', '10', '11'],
	},
	{
		id: 2,
		isMatIcon: false,
		iconName: 'fa-cog',
		description: 'login_credential',
		action: 'manage-credential',
		roles: ['1', '2', '6', '400001', '400028', '400035', '400036', '400037', '400038', '7', '5', '8', '9', '3', '10', '11'],
	},
	{
		id: 2,
		isMatIcon: true,
		iconName: 'garage',
		description: 'manage_plate',
		action: 'manage-plate',
		roles: ['1', '2', '6', '400001', '400028', '7', '5', '8', '9', '3', '11'],
	},
	{
		id: 3,
		isMatIcon: false,
		iconName: 'fa-car',
		description: 'my_vehicle',
		action: '/profile/vehicle',
		roles: ['1', '5', '8', '9'],
	},
	{
		id: 4,
		isMatIcon: true,
		iconName: 'toggle_off',
		description: 'choose_profile',
		action: 'toggle_off',
		roles: [],
	},
	{
		id: 5,
		isMatIcon: true,
		iconName: 'person_add',
		description: 'user_connect',
		action: 'user_connect',
		roles: [],
	},
	{
		id: 6,
		isMatIcon: true,
		iconName: 'manage_accounts',
		description: 'choose_user',
		action: 'manage_accounts',
		roles: [],
	},
	{
		id: 6,
		isMatIcon: true,
		iconName: 'supervisor_account',
		description: 'manage_sales',
		action: 'supervisor_account',
		roles: [],
	},
	{
		id: 7,
		isMatIcon: true,
		iconName: 'logout',
		description: 'logout',
		action: 'logout',
		roles: [],
	},
]
